import { DownloadIcon } from "@heroicons/react/outline";

import { ProgressRadial } from "@/components/ui/ProgressRadial";
import { cn } from "@/lib/utils";

interface DownloadIconWithProgressProps {
  progress: number | null;
  iconClassName?: string;
  progressClassName?: string;
  containerClassName?: string;
}

export const DownloadIconWithProgress = ({
  progress,
  iconClassName = "h-5 w-5",
  progressClassName = "bg-gray-100",
  containerClassName,
}: DownloadIconWithProgressProps) => {
  if (progress !== null) {
    return (
      <div
        className={cn(
          "relative flex h-5 w-5 flex-shrink-0 items-center justify-center",
          containerClassName,
        )}
      >
        <DownloadIcon className={iconClassName} />
        <ProgressRadial
          progress={progress}
          className={cn("absolute inset-0 h-5 w-5 rounded-full", progressClassName)}
        />
      </div>
    );
  }
  return <DownloadIcon className={iconClassName} />;
};

export const getExportLabel = (progress: number | null, defaultLabel = "Export to CSV"): string => {
  if (progress !== null) {
    return `Exporting ${Math.round(progress)}%`;
  }
  return defaultLabel;
};
